/* SoluHogar — Agregar al carrito (convive con el formulario COD de Releasit) */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastTimer = null;

  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function toast(text) {
    var el = document.querySelector('[data-cart-toast]');
    if (!el) return;
    var out = el.querySelector('[data-cart-toast-text]');
    if (out) out.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3600);
  }

  function addToCart(button) {
    var section = button.closest('[data-product-section]');
    var form = (section && section.querySelector('.product-form')) || button.closest('.product-form');
    if (!form || button.disabled) return;
    var label = button.querySelector('[data-add-to-cart-label]') || button;
    var message = form.querySelector('[data-form-message]');
    var original = label.textContent;

    button.disabled = true;
    label.textContent = 'AGREGANDO…';
    if (message) message.textContent = '';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'No pudimos agregar este producto.');
          return data;
        });
      })
      .then(function (data) {
        label.textContent = 'AGREGADO ✓';
        refreshCount();
        toast((data.product_title || 'Producto') + ' agregado al carro');
        setTimeout(function () { button.disabled = false; label.textContent = original; }, 1800);
      })
      .catch(function (error) {
        if (message) message.textContent = error.message;
        button.disabled = false;
        label.textContent = original;
      });
  }

  function syncVariant(select) {
    var section = select.closest('[data-product-section]');
    if (!section) return;
    var button = section.querySelector('[data-add-to-cart]');
    if (!button) return;
    var label = button.querySelector('[data-add-to-cart-label]') || button;
    var text = button.getAttribute('data-add-to-cart-text') || label.textContent.trim() || 'AGREGAR AL CARRITO';
    button.setAttribute('data-add-to-cart-text', text);
    var option = select.options[select.selectedIndex];
    var available = option && option.dataset.available === 'true';
    button.disabled = !available;
    label.textContent = available ? text : 'AGOTADO';
  }

  function bind(scope) {
    scope.querySelectorAll('[data-add-to-cart]:not([data-atc-ready])').forEach(function (button) {
      button.dataset.atcReady = 'true';
      var label = button.querySelector('[data-add-to-cart-label]') || button;
      button.setAttribute('data-add-to-cart-text', label.textContent.trim());
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(button);
      });
    });

    scope.querySelectorAll('[data-scroll-to-add]:not([data-atc-shortcut-ready])').forEach(function (shortcut) {
      shortcut.dataset.atcShortcutReady = 'true';
      shortcut.addEventListener('click', function () {
        var section = shortcut.closest('[data-product-section]') || document;
        var button = section.querySelector('[data-add-to-cart]');
        if (button && !button.disabled) addToCart(button);
      });
    });

    scope.querySelectorAll('[data-variant-select]:not([data-atc-variant-ready])').forEach(function (select) {
      select.dataset.atcVariantReady = 'true';
      select.addEventListener('change', function () { syncVariant(select); });
    });
  }

  function start() { bind(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
